import React, { useState } from "react";
import ReactDOM from "react-dom";
import { Space, Spin, Progress } from "antd";
import {
    FilePdfOutlined,
    EyeOutlined,
    FileExcelOutlined,
    RightOutlined,
    LoadingOutlined,
} from "@ant-design/icons";
import { motion, AnimatePresence } from "framer-motion";

const FloatingActionButtons = ({
    handleDownloadPDF,
    handleOpenPDF,
    handleExportExcel,
    pdfLoading,
    pdfProgress,
}) => {
    const [hoveredIndex, setHoveredIndex] = useState(null);

    const containerStyle = {
        position: "fixed",
        top: "50%",
        left: 20,
        transform: "translateY(-50%)",
        zIndex: 1000,
    };

    const buttons = [
        {
            icon: <FilePdfOutlined style={{ fontSize: 20 }} />,
            label: "Descargar PDF",
            color: "#3E246B",
            onClick: handleDownloadPDF,
        },
        {
            icon: <EyeOutlined style={{ fontSize: 20 }} />,
            label: "Ver PDF",
            color: "#293790",
            onClick: handleOpenPDF,
        },
        {
            icon: <FileExcelOutlined style={{ fontSize: 20 }} />,
            label: "Exportar Excel",
            color: "#62c190",
            onClick: handleExportExcel,
        },
    ];

    return (
        <>
        <div style={containerStyle}>
            <Space direction="vertical" size="middle">
                {buttons.map((btn, index) => {
                    const isHovered = hoveredIndex === index;

                    return (
                        <motion.div
                            key={index}
                            onMouseEnter={() => setHoveredIndex(index)}
                            onMouseLeave={() => setHoveredIndex(null)}
                            onClick={btn.onClick}
                            initial={false}
                            animate={{ width: isHovered ? 200 : 56 }}
                            transition={{ duration: 0.3 }}
                            style={{
                                height: 56,
                                backgroundColor: btn.color,
                                borderRadius: 28,
                                display: "flex",
                                alignItems: "center",
                                boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                                cursor: "pointer",
                                overflow: "hidden",
                                padding: "0 16px",
                            }}
                        >
                            {/* Ícono principal */}
                            <div
                                style={{
                                    color: "white",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    minWidth: 24,
                                }}
                            >
                                {btn.icon}
                            </div>

                            {/* Transición entre flecha y texto */}
                            <AnimatePresence mode="wait" initial={false}>
                                {isHovered ? (
                                    <motion.span
                                        key="text"
                                        initial={{ opacity: 0, x: 10 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        exit={{ opacity: 0, x: 10 }}
                                        transition={{ duration: 0.2 }}
                                        style={{
                                            color: "white",
                                            fontWeight: 500,
                                            whiteSpace: "nowrap",
                                            marginLeft: 10,
                                        }}
                                    >
                                        {btn.label}
                                    </motion.span>
                                ) : (
                                    <motion.div
                                        key="arrow"
                                        initial={{ opacity: 0, x: 10 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        exit={{ opacity: 0, x: 10 }}
                                        transition={{ duration: 0.2 }}
                                        style={{
                                            color: "white",
                                            marginLeft: 10,
                                        }}
                                    >
                                        <RightOutlined />
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </motion.div>
                    );
                })}
            </Space>
        </div>

        {pdfLoading && ReactDOM.createPortal(
                <div style={{
                    position: 'fixed',
                    top: 0, left: 0, right: 0, bottom: 0,
                    background: 'linear-gradient(135deg, rgba(62,36,107,0.92) 0%, rgba(41,55,144,0.92) 100%)',
                    backdropFilter: 'blur(8px)',
                    display: 'flex', flexDirection: 'column',
                    alignItems: 'center', justifyContent: 'center',
                    zIndex: 9999,
                }}>
                    <div style={{
                        background: 'rgba(255,255,255,0.12)',
                        borderRadius: 24,
                        padding: '48px 56px',
                        display: 'flex', flexDirection: 'column',
                        alignItems: 'center', gap: 20,
                        boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
                        minWidth: 300,
                    }}>
                        <div style={{
                            width: 72, height: 72,
                            borderRadius: '50%',
                            background: 'rgba(255,255,255,0.15)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}>
                            <FilePdfOutlined style={{ fontSize: 36, color: '#fff' }} />
                        </div>
                        <div style={{ color: '#fff', fontSize: 18, fontWeight: 600, textAlign: 'center' }}>
                            Generando PDF
                        </div>
                        <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 14, textAlign: 'center', lineHeight: 1.5 }}>
                            Este proceso puede tomar un momento...
                        </div>
                        {pdfProgress && (
                            <div style={{ width: '100%', marginTop: 4 }}>
                                <Progress
                                    percent={Math.round((pdfProgress.current / pdfProgress.total) * 100)}
                                    strokeColor={{ from: '#36d1c4', to: '#5b8def' }}
                                    trailColor="rgba(255,255,255,0.15)"
                                    showInfo={false}
                                    strokeWidth={8}
                                    style={{ marginBottom: 8 }}
                                />
                                <div style={{
                                    color: 'rgba(255,255,255,0.85)', fontSize: 13,
                                    textAlign: 'center', fontVariantNumeric: 'tabular-nums',
                                }}>
                                    Página {pdfProgress.current} de {pdfProgress.total}
                                </div>
                            </div>
                        )}
                        {!pdfProgress && (
                            <Spin indicator={<LoadingOutlined style={{ fontSize: 28, color: 'rgba(255,255,255,0.8)' }} spin />} />
                        )}
                    </div>
                </div>
            , document.body)}
        </>
    );
};

export default FloatingActionButtons;
